import type { FundsFeatureConfig } from '../../../types/features/FundsFeatureConfig';

export const funds: FundsFeatureConfig = {
    showTooltipForHU: false,
    showNotes: true,
};
